import React from "react"
import PropTypes from "prop-types"
import { useField } from "formik"

import StyledSelect from "./styles"

const Select = ({ name, label, options }) => {
  const [field, meta] = useField({ name })
  return (
    <StyledSelect>
      <label htmlFor={name} className="inp-label">
        {label}
      </label>
      <select {...field} id={name}>
        <option value="">{" "}</option>
        {options.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      {meta.touched && meta.error ? (
        <p className="inp-error">{meta.error}</p>
      ) : null}
    </StyledSelect>
  )
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
}

export default Select
